import type { OrderState } from '@model/Order.model';
import type { ActionWithPayload } from '@model/Store.model';
import {
  CLEAR_ORDER,
  SET_SELECTED_ORDER_DELIVERY_ADDRESS,
  SET_ORDER_ITEMS,
  SET_SELECTED_ORDER_CARRIER,
  SET_SELECTED_ORDER_PAYMENT_METHOD,
} from 'Data/Order/OrderActionTypes';

const INITIAL_STATE: OrderState = {
  selectedDeliveryCarrier: null,
  selectedPaymentMethod: null,
  selectedDeliveryAddress: null,
  items: [],
};

export const OrderReducer = (
  state: OrderState = INITIAL_STATE,
  action: ActionWithPayload
): OrderState => {
  switch (action.type) {
    case SET_SELECTED_ORDER_CARRIER:
      return {
        ...state,
        selectedDeliveryCarrier: action.payload?.carrier ?? null,
      };

    case SET_SELECTED_ORDER_PAYMENT_METHOD:
      return { ...state, selectedPaymentMethod: action.payload?.method ?? null };

    case SET_ORDER_ITEMS:
      return { ...state, items: action.payload?.items ?? [] };

    case CLEAR_ORDER:
      return INITIAL_STATE;

    case SET_SELECTED_ORDER_DELIVERY_ADDRESS:
      return { ...state, selectedDeliveryAddress: action.payload?.address ?? null };

    default:
      return state;
  }
};
